module["exports"] = ["کارخانه", "و پسران", "شرکت با مسئولیت محدود", "گروه"];